module.exports = __webpack_public_path__ + "img/job_booking01.461def35.png";